export const environment = {
  production: true,
  platformApiUrl: '/api',
  apiUrl: 'http://localhost:3000/api',
  publicUrl: 'http://localhost:3000/public',
  // apiUrl: 'http://localhost:3000/api',
  // publicUrl: 'http://localhost:3000/public',
  javaApiUrl: 'http://26.58.110.239:3001/api',
  javaApiServerUrl: 'http://26.58.110.239:3002/api',
  crafatarApiUrl: 'https://crafatar.com',
  minecraftApiUrl: 'https://minecraft-api.com/api'
};
